export const sortTypeDict = {
  espn: 'espn',
  twentyfoursevensports: '247',
  rivals: 'rivals',
  on3: 'on3',
  industry: 'industry',
  247: '247',
} as const;

export type IndustryComparisonRatingType = keyof typeof sortTypeDict;
